<app-kontable
  [service]="srvStoreConfiguration"
  [paginationType]="paginationType"
  [title]="'storeConfigurationList.listTitle' | translate"
  [columns]="[
    {field: 'store_id', title: 'storeConfigurationList.scope_type', filterType: 0, bodyTemplate: scopeTypeTemplate},
    {field: 'store_or_division_name', title: 'storeConfigurationList.ambito', filterType: 1},
    {field: 'date_start', title: 'storeConfigurationList.date_start', type: 'date', filterType: dateFilter},
    {field: 'date_end', title: 'storeConfigurationList.date_end', type: 'date', filterType: dateFilter},
    {field: 'validity_status', title: 'common.status', bodyTemplate: statusTemplate, filterType: selectFilter, filterOptions: {values: statusOptions}},
    {field: 'front_end_name', title: 'storeConfigurationList.front_end', filterType: selectFilter, filterOptions: {values: frontEndOptions}},
    {field: 'promotion_name', title: 'storeConfigurationList.promotion', filterType: selectFilter, filterOptions: {values: promotionOptions}},
    {field: 'customer_name', title: 'storeConfigurationList.customer_system', filterType: selectFilter, filterOptions: {values: customerOptions}},
    {field: 'loyalty_name', title: 'storeConfigurationList.loyalty_system', filterType: selectFilter, filterOptions: {values: loyaltyOptions}},
    {field: 'analytics_name', title: 'storeConfigurationList.analytics_system', filterType: selectFilter, filterOptions: {values: analyticsOptions}},
    {field: 'backoffice_name', title: 'storeConfigurationList.backoffice_system', filterType: selectFilter, filterOptions: {values: backofficeOptions}},
    {field: 'couponing_name', title: 'storeConfigurationList.couponing_system', filterType: selectFilter, filterOptions: {values: couponingOptions}},
    {field: 'ochannel_code', title: 'campaign.touchpoint', filterType: selectFilter, filterOptions: {values: channelOptions}}
  ]"
  [titles]="[]"
  [showInfoButton]="false"
  [showRecoverButton]="false"
  [showDetailsButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [showAddButton]="true"
  [showReport]="false"
  [additionalRowCommands]="rowActionsTemplate"
  (onAdd)="showAddOrEditDialog(null)"
  (onEdit)="showAddOrEditDialog($event)"
  (onRemove)="deleteItem($event)"
  [(fireNewDataAvailable)]="newDataAvailable"
>
  <ng-template #scopeTypeTemplate let-row>
    <span class="scope-badge" [ngClass]="row.store_id ? 'badge-store' : 'badge-division'">
      {{ (row.store_id ? 'storeConfigurationList.store' : 'storeConfigurationList.division') | translate }}
    </span>
  </ng-template>

  <ng-template #statusTemplate let-row>
    <div class="status-badge-table" [ngClass]="'badge-' + row.validity_status.toLowerCase()">
      <span class="status-dot" [ngClass]="'dot-' + row.validity_status.toLowerCase()"></span>
      {{ 'status.' + row.validity_status.toLowerCase() | translate }}
    </div>
  </ng-template>

  <ng-template #rowActionsTemplate let-row>
    <button pButton type="button" icon="fa fa-eye" class="ui-button-info"
      *ngIf="row.validity_status === 'EXPIRED'"
      pTooltip="{{ 'common.view' | translate }}" tooltipPosition="top"
      (click)="viewItem(row)"></button>
    <button pButton type="button" icon="fa fa-pencil" class="ui-button-success"
      *ngIf="row.validity_status !== 'EXPIRED'"
      pTooltip="{{ 'common.edit' | translate }}" tooltipPosition="top"
      (click)="showAddOrEditDialog(row)"></button>
    <button pButton type="button" icon="fa fa-trash" class="ui-button-danger"
      *ngIf="row.validity_status !== 'EXPIRED'"
      pTooltip="{{ 'common.delete' | translate }}" tooltipPosition="top"
      (click)="deleteItem(row)"></button>
  </ng-template>
</app-kontable>

<p-dialog *ngIf="viewRow" header="{{ 'storeConfigurationList.view_title' | translate }}" [(visible)]="showViewDialog"
  [modal]="true" [resizable]="false" [draggable]="false" [width]="560" styleClass="view-dialog" (onHide)="closeViewDialog()">
  <div class="view-info">
    <div class="view-row">
      <span class="view-label">{{ 'storeConfigurationList.ambito' | translate }}</span>
      <span class="view-value">{{ viewRow.store_or_division_name }}</span>
    </div>
    <div class="view-row">
      <span class="view-label">{{ 'common.status' | translate }}</span>
      <div class="status-badge-table" [ngClass]="'badge-' + viewRow.validity_status.toLowerCase()">
        <span class="status-dot" [ngClass]="'dot-' + viewRow.validity_status.toLowerCase()"></span>
        {{ 'status.' + viewRow.validity_status.toLowerCase() | translate }}
      </div>
    </div>
    <div class="view-row">
      <span class="view-label">{{ 'storeConfigurationList.date_start' | translate }}</span>
      <span class="view-value">{{ viewRow.date_start | date:'dd/MM/yyyy' }}</span>
    </div>
    <div class="view-row">
      <span class="view-label">{{ 'storeConfigurationList.date_end' | translate }}</span>
      <span class="view-value">{{ viewRow.date_end | date:'dd/MM/yyyy' }}</span>
    </div>
    <div class="view-row">
      <span class="view-label">{{ 'storeConfigurationList.front_end' | translate }}</span>
      <span class="view-value">{{ viewRow.front_end_name || '-' }}</span>
    </div>
    <div class="view-row">
      <span class="view-label">{{ 'storeConfigurationList.promotion' | translate }}</span>
      <span class="view-value">{{ viewRow.promotion_name || '-' }}</span>
    </div>
    <div class="view-row">
      <span class="view-label">{{ 'storeConfigurationList.customer_system' | translate }}</span>
      <span class="view-value">{{ viewRow.customer_name || '-' }}</span>
    </div>
    <div class="view-row">
      <span class="view-label">{{ 'storeConfigurationList.loyalty_system' | translate }}</span>
      <span class="view-value">{{ viewRow.loyalty_name || '-' }}</span>
    </div>
    <div class="view-row">
      <span class="view-label">{{ 'storeConfigurationList.analytics_system' | translate }}</span>
      <span class="view-value">{{ viewRow.analytics_name || '-' }}</span>
    </div>
    <div class="view-row">
      <span class="view-label">{{ 'storeConfigurationList.backoffice_system' | translate }}</span>
      <span class="view-value">{{ viewRow.backoffice_name || '-' }}</span>
    </div>
    <div class="view-row">
      <span class="view-label">{{ 'storeConfigurationList.couponing_system' | translate }}</span>
      <span class="view-value">{{ viewRow.couponing_name || '-' }}</span>
    </div>
    <div class="view-row">
      <span class="view-label">{{ 'storeConfigurationList.ochannel' | translate }}</span>
      <span class="view-value">{{ viewRow.ochannel_code || '-' }}</span>
    </div>
  </div>

  <div class="dialog-footer">
    <button type="button" pButton label="{{ 'common.close' | translate }}" class="btn-cancel" (click)="closeViewDialog()"></button>
  </div>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/store-configuration/store-configuration.component.html